import { render } from "./register-attribute-list.vue?vue&type=template&id=6c2e0b81&scoped=true"
import script from "./register-attribute-list.vue?vue&type=script&lang=js"
export * from "./register-attribute-list.vue?vue&type=script&lang=js"

import "./register-attribute-list.vue?vue&type=style&index=0&id=6c2e0b81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2e0b81"]])

export default __exports__